import {
    createContext,
    useContext,
} from 'react'

// API состояния UI в ЛК пользователя.
export interface CabinetContextApiProps {
    setSideMenuType: (menu: 'profile' | 'finances' | null) => void
    setContentContainerId: (id: string | null) => void
}

// Состояние контекста по умолчанию для API.
const apiContextDefaults: CabinetContextApiProps = {
    setSideMenuType() {
    },
    setContentContainerId() {
    },
}

// Контекста Кабинета пользователя.
export const CabinetContextApi = createContext<CabinetContextApiProps>(apiContextDefaults)

// API Кабинета пользователя.
export function useCabinetContextApi() {
    return useContext(CabinetContextApi)
}
